import responseData from "./sidebarSettingsResponse.json"

export const getSettings = () => async () => {
  return responseData
}
